import Load from 'components/Load';
import React from 'react';
import { Route } from 'react-router-dom';
import basePath from 'utils/basePath';

const AsyncRescheduleDateTime = Load(
  () =>
    import(
      /* webpackChunkName: "reschedule" */ './components/RescheduleDateTimeContainer'
    ),
);
const AsyncRescheduleSuccess = Load(
  () =>
    import(
      /* webpackChunkName: "reschedule" */ './components/RescheduleSuccess'
    ),
);
const AsyncCancelSuccess = Load(
  () =>
    import(/* webpackChunkName: "reschedule" */ './components/CancelSuccess'),
);
const AsyncNewHost = Load(
  () =>
    import(
      /* webpackChunkName: "reschedule" */ './components/NewHostContainer'
    ),
);

const RescheduleRoutes = [
  <Route
    key="reschedule-datetime"
    path={`${basePath}/reschedule/:bookingId/date-time`}
  >
    <AsyncRescheduleDateTime />
  </Route>,
  <Route
    key="reschedule-success"
    path={`${basePath}/reschedule/:bookingId/success`}
  >
    <AsyncRescheduleSuccess />
  </Route>,
  <Route
    key="reschedule-cancel"
    path={`${basePath}/reschedule/:bookingId/cancel-success`}
  >
    <AsyncCancelSuccess />
  </Route>,
  <Route
    key="reschedule-newhost"
    path={`${basePath}/reschedule/:bookingId/new-host`}
  >
    <AsyncNewHost />
  </Route>,
];

export default RescheduleRoutes;
